<template>
  <div class="rt-advance-table-group">
    <el-checkbox
      v-if="showCheckAll"
      :indeterminate="isIndeterminate"
      v-model="checkAll"
      class="rt-check-all"
      @change="handleCheckAllChange"
      >全选</el-checkbox
    >
    <el-checkbox-group
      v-bind="$attrs"
      v-model="selectValue"
      :class="classes"
      @change="handelChange"
    >
      <slot>
        <rt-advance-table-item
          v-for="(item, index) in labelList"
          :label="item[valueKey]"
          :key="index"
          >{{ item[nameKey] }}
        </rt-advance-table-item>
      </slot>
    </el-checkbox-group>
    <div v-if="showCollapse" class="rt-advance-table-group-collapse">
      <div v-if="packUp" class="more-item" @click="packUpItems">
        <p>收起全部</p>
        <rt-icon name="rt-base-arrow_up"></rt-icon>
      </div>
      <div v-else class="more-item" @click="rollUpItems">
        <p>展开更多</p>
        <rt-icon name="rt-base-arrow_down"></rt-icon>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RtAdvanceTableGroup',
  props: {
    value: Array,
    labelList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    alias: {
      type: Object,
      default: () => {
        return {
          valueKey: 'value',
          nameKey: 'name'
        };
      }
    },
    vertical: {
      type: Boolean,
      default: false
    },
    showCheckAll: {
      type: Boolean,
      default: false
    },
    showCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectValue: this.value,
      isIndeterminate: true,
      checkAll: false,
      packUp: false
    };
  },
  computed: {
    valueKey() {
      return this.alias.valueKey;
    },
    nameKey() {
      return this.alias.nameKey;
    },
    classes() {
      return [
        'rt-checkbox-group',
        {
          'rt-checkbox-group-vertical': this.vertical
        }
      ];
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.selectValue = newVal;
    }
  },
  methods: {
    handelChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.labelList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.labelList.length;
      this.$emit('input', value);
    },
    handleCheckAllChange(value) {
      let allValue = [];
      this.labelList.forEach(item => {
        allValue.push(item.value);
      });
      this.selectValue = value ? allValue : [];
      console.log(allValue);
      this.isIndeterminate = false;
      this.$emit('input', this.selectValue);
    },
    packUpItems() {
      this.$emit('pack-up');
      this.packUp = false;
    },
    rollUpItems() {
      this.$emit('roll-up');
      this.packUp = true;
    }
  }
};
</script>

<style lang="less">
.rt-advance-table-group {
  overflow: hidden;
  .rt-check-all {
    width: 100%;
    margin-bottom: 10px;
    background: #f0f3f7;
    padding: 10px;
    .el-checkbox__input {
      .el-checkbox__inner {
        width: 16px;
        height: 16px;
        &::before {
          top: 6px;
        }
        &::after {
          left: 5px;
          height: 8px;
        }
      }
    }
    .el-checkbox__label {
      color: #6388c2;
      font-size: 14px;
    }
  }
  .rt-checkbox-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;

    .rt-advance-table-item {
      width: 47%;
      margin-bottom: 10px;
      background: #f5f7fa;
      padding: 14px 10px;

      .el-checkbox {
        .el-checkbox__input {
          position: absolute;
          top: 1px;
          left: 0;
          .el-checkbox__inner {
            width: 16px;
            height: 16px;
            &::after {
              left: 5px;
              height: 8px;
            }
          }
        }
        .el-checkbox__label {
          padding-left: 31px;
          font-size: 16px;
          color: #143e81;

          .el-row {
            margin: 15px 0 0 !important;
          }
        }
      }
    }
  }
  .rt-checkbox-group-vertical {
    flex-direction: column;
    .rt-advance-table-item {
      width: 100%;
    }
  }
  .rt-advance-table-group-collapse {
    .more-item {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #a9c2e8;
      margin-top: 10px;

      .rt-icon {
        line-height: 1;
        margin-left: 7px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtAdvanceTableGroup.vue?40b3b4a0